import { useEffect, useState } from 'react';
import { Dialog } from '@headlessui/react';
import { useActions, useAppState } from '@frontend/howl-web-app/overmind';
import { XIcon } from '@heroicons/react/solid';

export const ReservedModal = () => {
  const { modal } = useAppState().creatorCampaignCenter;
  const { type, isVisible, campaignName } = modal;
  const [isOpen, setIsOpen] = useState(isVisible && type === 'reserved');
  const { clearCampaignCenterModal } = useActions().creatorCampaignCenter;

  useEffect(() => {
    setIsOpen(isVisible && type === 'reserved');
  }, [modal]);

  return (
    <Dialog
      open={isOpen}
      onClose={() => clearCampaignCenterModal()}
      className="fixed z-50 inset-0 overflow-y-auto"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30 " />
        {/* This element is to trick the browser into centering the modal contents. */}
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full">
          <div data-cy="reserved-modal" className="bg-white">
            <div className="px-8 py-6 text-white bg-secondary-purple-1000 flex justify-between">
              <Dialog.Title className="m-0" data-cy="reserved-modal-title">
                {`Congrats, you reserved "${campaignName}".`}
              </Dialog.Title>
              <button
                data-cy="reserved-modal-x-icon"
                onClick={() => setIsOpen(false)}
                className="border-none h-4 w-4 cursor-pointer p-0 flex"
              >
                <XIcon className="h-4 w-4" />
              </button>
            </div>
            <div className="px-8">
              <Dialog.Description>
                <p className="font-bold m-0 p-0">
                  When you reserve a campaign, you:{' '}
                </p>
                <ul className="pl-4">
                  <li className="mb-4">
                    Get the higher rates for the products in the campaign
                  </li>
                  <li className="mb-4">
                    See the campaign in your reserved calendar view so you can
                    plan ahead
                  </li>
                  <li className="mb-4">
                    Get notifications when the campaign goes live or has updates
                  </li>
                  <li className="mb-4">
                    See analytics on your specific campaign
                  </li>
                </ul>
              </Dialog.Description>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
